import { days } from 'pages/Employees/employeesData'
import { tokens } from 'styling/tokens'
import { IShiftProgramRow } from 'types/shiftPrograms.interface'
import { IShiftProgramRunResponse } from 'types/api/operationsShiftProgramsApi.interface'

export const getShiftProgramStatusLabel = (status: number) => (status === 2 ? 'PAUSED' : 'ACTIVE')

export const getShiftProgramStatusColor = (status: number) =>
  status === 2 ? tokens.text.muted : tokens.status.success.fg

export const formatWeeklyDays = (weeklyDays?: number[]) =>
  weeklyDays?.length
    ? weeklyDays.map((day) => days.find((d) => d.value === day)?.label ?? day).join(', ')
    : '-'

export const getRunStatusLabel = (run: IShiftProgramRunResponse) => {
  if (!run.finishedAt) return 'Running'
  if (run.errorCount > 0) return 'Failed'
  return 'Completed'
}

export const getRunStatusColor = (run: IShiftProgramRunResponse) => {
  if (!run.finishedAt) return tokens.accent.base
  if (run.errorCount > 0) return tokens.status.danger.fg
  return tokens.status.success.fg
}

export const MOCK_SHIFT_PROGRAMS: IShiftProgramRow[] = [
  {
    id: 1,
    title: 'Drill-rig morning huddle',
    meta: 'Site #1 · Dept #1 · Daily · 1 shift',
    frequency: 'DAILY',
    lastRun: '2024-05-14 05:33',
    status: 'active',
  },
  {
    id: 2,
    title: 'Weekly conveyor inspection',
    meta: 'Site #2 · Dept #4 · Weekly: Mon, Thu · 1 shift',
    frequency: 'WEEKLY',
    lastRun: '2024-05-13 06:00',
    status: 'active',
  },
  {
    id: 3,
    title: 'North Pit — pre-shift safety inspection',
    meta: 'Site #1 · Dept #1 · Every shift · 2 shifts',
    frequency: 'EVERY SHIFT',
    lastRun: '2024-05-14 06:00',
    status: 'active',
  },
  {
    id: 4,
    title: 'Pit S-1-A geotech walk',
    meta: 'Site #2 · Dept #3 · Custom: every 3d · 1 shift',
    frequency: 'CUSTOM',
    lastRun: '2024-05-12 07:00',
    status: 'active',
  },
  {
    id: 5,
    title: 'Night-shift fatigue check',
    meta: 'Site #1 · Dept #1 · Every shift · 1 shift',
    frequency: 'EVERY SHIFT',
    lastRun: '2024-05-10 18:30',
    status: 'paused',
  },
]
